import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./CandidateForm.scss";

function CandidateForm({ startTest }) {
  // Validation Schema
  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Name is required")
      .min(2, "Name must be at least 2 characters"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    phone: Yup.string()
      .required("Phone number is required")
      .matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number"),
  });

  return (
    <div className="form-container">
      <h2>Data Analysis Internship – Aptitude Test</h2>

      <Formik
        initialValues={{ name: "", email: "", phone: "" }}
        validationSchema={validationSchema}
        onSubmit={(values) => startTest(values)}
      >
        {() => (
          <Form>
            {/* Name */}
            <Field name="name" placeholder="Full Name" />
            <ErrorMessage
              name="name"
              component="div"
              className="error-text"
            />

            {/* Email */}
            <Field name="email" placeholder="Email" />
            <ErrorMessage
              name="email"
              component="div"
              className="error-text"
            />

            {/* Phone */}
            <Field name="phone" placeholder="Phone Number" />
            <ErrorMessage
              name="phone"
              component="div"
              className="error-text"
            />

            <button type="submit">Start Test</button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default CandidateForm;
